import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    product: [
      { label: 'Funcionalidades', href: '#funcionalidades' },
      { label: 'Como Funciona', href: '#embarque-flow' },
      { label: 'Preços', href: '#pricing' },
      { label: 'Fases de Implantação', href: '#phases' }
    ],
    company: [
      { label: 'Sobre a WCOM', href: 'https://wcom.digital' },
      { label: 'Contato', href: '#agendar-demo' }
    ],
    resources: [
      { label: 'Central de Ajuda', href: '#' },
      { label: 'Blog', href: '#' },
      { label: 'Documentação', href: '#' },
      { label: 'API', href: '#' }
    ]
  };

  const socialLinks = [
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Twitter, href: '#', label: 'Twitter' }
  ];

  const scrollToSection = (href) => {
    if (href.startsWith('#')) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="bg-[#0f1a36] text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16">
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12">
            {/* Brand Column */}
            <div className="lg:col-span-2">

              <h3 className="text-3xl text-white tracking-tight font-['Sora']">
  <span className="font-extrabold">WCOM</span>
  <span className="font-normal">Pass</span>
</h3>
              <p className="text-gray-300 mb-6 leading-relaxed">
                Sistema completo de gestão de transporte condominial com tecnologia NFC, 
                rastreabilidade em tempo real e governança operacional.
              </p>
              
              <div className="space-y-3">
                <a 
                  href="mailto:contato@wcom.digital"
                  className="flex items-center gap-3 text-gray-300 hover:text-[#007bff] transition-colors"
                >
                  <Mail className="w-5 h-5" />
                  contato@wcom.digital
                </a>
                
                <a 
                  href="tel:+5521992575060"
                  className="flex items-center gap-3 text-gray-300 hover:text-[#007bff] transition-colors"
                >
                  <Phone className="w-5 h-5" />
                  (21) 99257-5060
                </a>
                
                <div className="flex items-start gap-3 text-gray-300">
                  <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <span>Rio de Janeiro, RJ - Brasil</span>
                </div>
              </div>
            </div>

            {/* Product Links */}
            <div>
              <h4 className="text-lg font-bold text-white mb-4">
                Produto
              </h4>
              <ul className="space-y-3">
                {footerLinks.product.map((link, index) => (
                  <li key={index}>
                    <button
                      onClick={() => scrollToSection(link.href)}
                      className="text-gray-300 hover:text-[#007bff] transition-colors"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company Links */}
            <div>
              <h4 className="text-lg font-bold text-white mb-4">
                Empresa
              </h4>
              <ul className="space-y-3">
                {footerLinks.company.map((link, index) => (
                  <li key={index}>
                    <button
  onClick={() => {
    // Link externo → abre site
    if (link.href.startsWith("http")) {
      window.open(link.href, "_blank");
      return;
    }

    // Link interno (#...) → scroll suave
    scrollToSection(link.href);
  }}
  className="text-gray-300 hover:text-[#007bff] transition-colors"
>
  {link.label}
</button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Resources Links 
            <div>
              <h4 className="text-lg font-bold text-white mb-4">
                Recursos
              </h4>
              <ul className="space-y-3">
                {footerLinks.resources.map((link, index) => (
                  <li key={index}>
                    <a
                      href={link.href}
                      className="text-gray-300 hover:text-[#007bff] transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            */}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            {/* Copyright */}
            <div className="text-gray-400 text-sm">
              Copyright © {currentYear} WCOM Digital. Todos os direitos reservados.
            </div>

            {/* Social Links */}
            <div className="flex items-center gap-4">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.href}
                    aria-label={social.label}
                    className="w-10 h-10 rounded-full bg-white/10 hover:bg-[#007bff] flex items-center justify-center transition-colors"
                  >
                    <Icon className="w-5 h-5" />
                  </a>
                );
              })}
            </div>

            {/* Legal Links */}
            <div className="flex items-center gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-[#007bff] transition-colors">
                Privacidade
              </a>
              <a href="#" className="text-gray-400 hover:text-[#007bff] transition-colors">
                Termos de Uso
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
